// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6b18be69","703":"501a7dda"}[chunkId] + ".chunk.js";
};